import { NgModule } from '@angular/core';
import { DossierHelperService } from 'app/modules/dossier-area/services/dossier-helper/dossier-helper.service';

@NgModule({
  imports: [],
  providers: [DossierHelperService],
})
export class DossierHelperModule {}
